import React from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import axios from "axios";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ViewIcon from "@material-ui/icons/Visibility";
import { Container, Row, Col } from "shards-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import CustomToolbar from "../common/AddButton";

import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
//import { Store } from "../../flux";
import api from "../common/api";

class Users extends React.Component {
  constructor() {
    super();

    this.state = {
      data: "",
      isLoaded: false,
      users: []
    };
  }

  async componentDidMount() {
    await this.getUsers();
  }

  getUsers() {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.users().index(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ isLoaded: true, users: res.data });
      })
      .catch(err => {
        this.setState({ isLoaded: true, users: [] });
      });
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 8px 0px 8px",
            fontSize: "0.73rem"
          }
        }
      }
    });

  handleDelete(e, id) {
    e.preventDefault();
    this.state.users.map((val, idx) => {
      if (val.id === id) {
        this.setState({ delete_id: val.id });
      }
    });

    var message = "";
    if (id !== "") {
      message = "Está a punto de dar de baja al usuario. ¿Está seguro?";
    } else {
      message = "Hubo un problema al dar de baja al usuario.";
    }
    this.setState({ message: message, dialogOpen: true });
  }

  handleDialogClose(e) {
    e.preventDefault();
    this.setState({
      dialogOpen: false,
      errors: false,
      message: "",
      delete_id: ""
    });
  }

  handleRefresh(e) {
    e.preventDefault();
    window.location.href = `/users`;
  }

  confirmDelete() {
    const token = localStorage.getItem("userToken");
    return axios
      .delete(api.users().delete(this.state.delete_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ message: "Usuario dado de baja con éxito!" });
        this.setState({ errors: false });
        this.setState({ delete_id: "" });
      })
      .catch(err => {
        this.setState({ errors: true });
        this.setState({ delete_id: "" });
        this.setState({ message: "" });
      });
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: "name",
        label: "Nombre",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "email",
        label: "Email",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "rol",
        label: "Rol",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "cost_center.description",
        label: "Centro de Costo",
        options: {
          filter: true,
          filterType: "select",
          sort: true
        }
      },
      {
        name: "Acciones",
        label: "",
        options: {
          filter: false,
          setCellHeaderProps: () => ({ align: "center" }),
          customBodyRender: (value, tableMeta, updateValue) => {
            const rowId = tableMeta.rowData[0];
            //const rowId = 1
            return (
              <div className="row" style={{ display: "block" }}>
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none", backgroundColor: "green" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  href={"user/" + rowId + "/0"}
                >
                  <EditIcon fontSize="small" />
                </Fab>
                <Fab
                  color="secondary"
                  aria-label="edit"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  href={"user/" + rowId + "/1"}
                >
                  <ViewIcon fontSize="small" />
                </Fab>
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  onClick={e => {
                    this.handleDelete(e, rowId);
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </Fab>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      print: false,
      responsive: "stacked",
      selectableRowsOnClick: true,
      download: false,
      rowsPerPage: 10,
      customToolbar: () => {
        return <CustomToolbar url="new" />;
      },
      textLabels: {
        toolbar: {
          search: "Buscar",
          viewColumns: "Ver columnas",
          filterTable: "Filtros",
          downloadCsv: "Exportar XLS"
        },
        body: {
          noMatch: this.state.isLoaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          )
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        filter: {
          all: "Todos",
          title: "Filtros",
          reset: "Limpiar"
        }
      }
    };

    return (
      <Container fluid className="main-content-container px-4">
        <Row>
          <Col className="p-2">
            <div>
              <Dialog
                open={this.state.dialogOpen}
                onClose={e => this.handleDialogClose(e)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">Dar de baja!</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {this.state.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {!this.state.errors ? (
                    this.state.delete_id === "" ? (
                      <div>
                        <Button
                          onClick={e => {
                            this.handleRefresh(e);
                          }}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          onClick={e => this.handleDialogClose(e)}
                          color="primary"
                          autoFocus
                        >
                          Cancelar
                        </Button>
                        <Button
                          onClick={this.confirmDelete.bind(this)}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    )
                  ) : (
                    <div>
                      <Button
                        onClick={e => this.handleDialogClose(e)}
                        color="primary"
                      >
                        Continuar
                      </Button>
                    </div>
                  )}
                </DialogActions>
              </Dialog>
            </div>
            <div>
              <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title="Lista de Usuarios"
                  data={Object.values(this.state.users)}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Users;
